import React from 'react';

const MenuItem = ({ icon: Icon, label, onClick }) => {
  return (
    <div className="menu-item" onClick={onClick}>
      <Icon className="icon" />
      <span>{label}</span>
    </div>
  );
};

export default MenuItem;
